export const IS_INLINE_EDIT = "IS_INLINE_EDIT";